import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import renderOrgChartChildren from './renderOrgChartChildren';

class DrillDownOrgChart extends Component {

  // componentDidUpdate(prevProps) {
  //   if(this.orgChart) {
  //     const node = ReactDOM.findDOMNode(this.orgChart);
  //     this.scrollIntoView();
  //   }
  // }

  render() { 
    const {orgChart,onNodeClick,onDrillDownClick,selectedOffice,
      drillDownLevel,onDrillUpClick,allKpis,kpiType} = this.props;
      console.log(this.props)
    return ( 
      <div className="reactOrgChart" 
        ref={(r) => this.orgChart = r}
        style={{width:'90%',overflowX:'auto',marginTop:'2.5em',
          marginLeft:'auto',marginRight:'auto'}}>
        {renderOrgChartChildren(orgChart,onNodeClick,onDrillDownClick,drillDownLevel,
          onDrillUpClick,allKpis,selectedOffice,kpiType)}
      </div>
    );
  }
}
 
export default DrillDownOrgChart;